module.exports = __webpack_public_path__ + "front/img/bj.1d6a2424.jpg";